var Bajt = {};
(function($, B) {
    'use strict';
    $.extend(true, B, {
        isFunction:function(fn){
            return typeof fn === 'function';
        },
        runFunctions:function(functions){
            for(var f in functions){
                functions[f]();
            }
        },
        isNaturalNumber:function(n) {
            n = n.toString(); // force the value incase it is not
            var n1 = Math.abs(n),
                n2 = parseInt(n, 10);
            return !isNaN(n1) && n2 === n1 && n1.toString() === n;
        },
        toNaturalNumber:function(n) {
            return B.isNaturalNumber(n) ? parseInt(n) : Number.NaN;
        },
        getValue: function(obj, names) {
            var _compile=function(n){
                var i, j,
                    val=null, 
                    k=Object.keys(obj);
                
                for(i=0; i<n.length; i++){
                    var prefix=n[i]+'.';
                    for(j=0; j<k.length; j++){
                        if(k[j].indexOf(prefix) === 0){
                            val= val || {};
                            val[k[j].slice(prefix.length)] = obj[k[j]];
                        }
                    }
                }
                return val;
            };
            if (B.obj.is(obj) && !$.isArray(obj)) {
                if (typeof names === 'string') {
                    return obj.hasOwnProperty(names) ? obj[names] : _compile([names]);
                } else {                   
                    return obj.hasOwnProperty(names[0])
                        ? obj[names[0]]
                        : obj.hasOwnProperty(names[1])
                            ? obj[names[1]]
                            : _compile(names);
                }
            }else{
                return obj;
            }
        }
    });
   
})(jQuery, Bajt);
